import { Mortgage } from "../../model/MortgageExtensionModel";

export enum MortgageActionType {
    SetMortgage,
    SetNewMortgage,
}

export interface MortgageAction<T> {
    type: MortgageActionType;
    payload: T;
}

export function setMortgageAction(mortgage: Mortgage | undefined): MortgageAction<any> {
    return {
        type: MortgageActionType.SetMortgage,
        payload: { mortgage },
    };
}

export function setNewMortgageAction(newMortgage: Mortgage | undefined): MortgageAction<any> {
    return {
        type: MortgageActionType.SetNewMortgage,
        payload: { newMortgage },
    };
}
